
<template>
<v-app style="background-color: #F2E7D5; color:black; ">
  <cabecera/>
    <v-main style="background-color: #F2E7D5 !important; color:black; ">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

    <section  style="height: 500px; background-color:#393E46; "   >

        <v-row
align="center"
            justify="center"
        >
          <v-col
              class="text-center mt-4"
              cols="11"
              lg="6"
              md="6"
              sm="10"
              style="height: 100px;"
          >
            <h1 class="text-lg-h1  text-justify text-md-h1 text-sm-h1 text-h2 font-weight-bold" style="color: white;" >
              Software
            </h1>
            <h1 class="text-lg-h1   text-justify text-md-h1 text-sm-h1 text-h2 font-weight-bold textogradiente"  >
              Eventos
            </h1>
            <h1 class="text-lg-h1   text-justify text-md-h1 text-sm-h1 text-h2 font-weight-bold" style="color: white;" >
              Online
            </h1>
            <h6 class="subheading text-justify text-lg-h6 text-md-h6 text-sm-h6 text-h6 mt-lg-0 mt-md-0 mt-sm-0 mt-6" style="color: white;">
              Crea o Asiste a Eventos de la manera más rápida posible.
            </h6>
          </v-col>

        </v-row>

    </section>

    <section   style="background-color: #F2E7D5; color:black; border-top-left-radius:250px 100px; border-top-right-radius: 250px 100px; margin-top: -100px;  ">
      <v-tabs
          v-model="tab"
          centered
          dark
          icons-and-text
           background-color="#6D9886"
          color="#393E46"
          style="border-top-left-radius:250px 100px; border-top-right-radius: 250px 100px;"
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab
             href="#tab-discotecas">
          Fiestas
          <v-icon>fas fa-glass-cheers</v-icon>
        </v-tab>
        <v-tab
             href="#tab-eventos">
          Eventos
          <v-icon>fas fa-music</v-icon>
        </v-tab>
        <v-tab-item  key="tab-discotecas" value="tab-discotecas">
            <v-row class="pt-6 text-center white">
              <v-col cols="12" sm="12" md="12" lg="12">
                    <h1 class="display-1 font-weight-bold ">Explora la ciudad</h1>
        </v-col>
            </v-row>
          <v-row justify="center" class="text-center white mb-1" >

            <v-col cols="10" lg="3" sm="3" v-for="fiesta in fiestas" :key="fiesta.id" >
                <router-link :to="{ name: 'fiestalista', params: { id: fiesta.id }}" style="text-decoration: none !important;">
                  <v-card elevation="10" light color="#EFE5E2"
                >
                  <v-card-title   ><v-row  align="center" justify="center">
                    <v-col cols="8" lg="8" md="8" sm="8" >

                        <v-img v-if="fiesta.foto===''"  max-height="200" min-height="200" style="width:270px;" contain src="@/assets/sinimagen.jpeg" />


                        <v-img v-else  max-height="200" min-height="200"  style="width:270px;" contain :src="fiesta.foto"></v-img>

                    </v-col>
                  </v-row></v-card-title>
                  <v-card-text >

                    <v-row justify="center">
                      <v-col cols="12" lg="12" md="12" sm="12">
                      <h1 >{{fiesta.nombre}}</h1> </v-col>
                    </v-row>
                    <v-row justify="center" >
                      <v-col cols="12" lg="12" align="center" >
                        <h3>  {{formatDatee(fiesta.fechaInicio)}}</h3>
                      </v-col>
                    </v-row>

                  </v-card-text>
                </v-card></router-link>

            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item  key="tab-eventos" value="tab-eventos">
          <v-row  class=" pt-6 text-center white">
            <v-col cols="12" sm="12" md="12" lg="12">
              <h1 class="display-1 font-weight-bold ">Estos son los eventos que tenemos para ti</h1>
            </v-col>
          </v-row>
          <v-row justify="center" class="text-center white" >

            <v-col cols="12" lg="3" sm="3" v-for="fiesta in eventos" :key="fiesta.id" >
                <router-link :to="{ name: 'acto', params: { tag: fiesta.tag }}">
                <v-card elevation="10" class="ma-10"
                >
                  <v-card-text style=" height:280px">
                    <v-row justify="center">
                      <v-col cols="12" lg="6" md="6" sm="12">


                          <v-img v-if="fiesta.foto===''"   max-height="200" min-height="200" style="width:270px;"  contain src="@/assets/sinimagen.jpeg" />

                          <v-img v-else max-height="200" min-height="200" style="width:270px;"  contain :src="fiesta.foto"></v-img>

                      </v-col>
                    </v-row>   <v-row justify="center" >
                    <h1 >{{fiesta.nombre}}</h1> </v-row>
                    <v-row justify="center" align="center" >
                      <v-col cols="12" lg="12"  >
                        <h3>  {{formatDatee(fiesta.fechaInicio)}}</h3>
                      </v-col>
                    </v-row>

                  </v-card-text>
                </v-card></router-link>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs>
      </section>
      <section style="background-color: white; color: black;">
<adsensed ></adsensed>
      </section>
    </v-main>
    <piepagina/>
  <v-overlay :value="overlay">
    <v-img
        src="@/assets/loadtunay.gif"

    />
  </v-overlay>


  </v-app>
</template>

<script>
import axios from 'axios';


import cabecera from '../general/cabecera';
import piepagina from '../general/piepagina';
import moment from "moment-timezone";
import {mapGetters} from "vuex";
import store from "@/store";
import Adsensed from "@/components/modulo/adsensed";
import Cabecerabaja from "@/components/general/cabecerabaja";


  export default {
    name: 'homepage',
    title: 'Tunay Mi acceso de bolsillo',
    components: {
      Cabecerabaja,
      Adsensed,
    cabecera,
    piepagina,
  },
    data () {
      return {
        fiestas: [],
        eventos: [],
        negocios:[],
        email: '',
        tab: null,
        codigoUnico:'',
        rese:'',
        overlay:false,
        emailRules: [
          v => !!v || 'Se necesita el Email',
          v => /.+@.+/.test(v) || 'E-mail debe ser valido',
        ]
          }
    },
    mounted(){
      if(this.usuario.id>0){
        store.dispatch("conectarse")
      }
      this.traeClientes()
      this.fnBrowserDetect();
    },
    methods: {
      validarcodigo(){
        if(this.codigoUnico!== ''){
        this.$router.push({name:"validaqr",params:{codigo: this.codigoUnico}})
        }
      },
      fnBrowserDetect(){

        let userAgent = navigator.userAgent;

        if(userAgent.match(/chrome|chromium|crios/i)){
          this.rese = "chrome";
        }else if(userAgent.match(/firefox|fxios/i)){
          this.rese = "firefox";
        }  else if(userAgent.match(/safari/i)){
          this.rese = "safari";
        }else if(userAgent.match(/opr\//i)){
          this.rese = "opera";
        } else if(userAgent.match(/edg/i)){
          this.rese = "edge";
        }else{
          this.rese="No browser detection";
        }

      },

      formatDatee(value) {
        return moment(value).locale('es-pe').format("DD MMMM YYYY")
      },
      traeClientes(){
        this.overlay = true;
       axios.get("actos/activas", {
         headers: {
           'Accept': 'application/json',
           'Content-Type': 'application/json;charset=UTF-8'
         }
      })
      .then((response)  => {
        this.fiestas = response.data.filter(x=>x.temporada != null);
        this.eventos = response.data.filter(x=>x.temporada == null).filter(x=>x.eventoCategoria.publico === true)
        this.overlay = false;
      })
      .catch((error)  => {
        console.log(error);
        this.overlay = false;
      });
    },

    },
    computed: {
      // map `this.user` to `this.$store.getters.user`
      ...mapGetters({
        usuario: "usuario",
        conectado: "conectado"
      })
    }
  }
</script>
<style scoped>
.textogradiente {

  background: -webkit-linear-gradient(#eee, #333);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
